<template>
    <div>
        <van-sticky>
            <form action="#">
                <van-search
                    show-action
                    v-model="keyword"
                    placeholder="请输入搜索关键词"
                    @search="onSearch">
                    <template #action>
                        <van-button type="info" size="small" @click="onSearch">搜索</van-button>
                    </template>
                </van-search>
            </form>
            <van-dropdown-menu active-color="#1989fa">
                <drop-menu title="地区" url="Area/listAll" :data="{pid:'1'}" @change="okArea" value-key="code" :row-count="4" sub-title="选择地区"></drop-menu>
                <drop-menu title="行业" url="Type/listAll" :data="{akey:'industry'}" @change="okIndustry" sub-title="选择行业"></drop-menu>
                <van-dropdown-item v-model="time_rage" :options="option2" />
            </van-dropdown-menu>
            <div class="me-banner"></div>
        </van-sticky>
<!--        <flat-list url="Bids/listPage" list-class="margin-top" :data="{'type_industry_id':type_industry_id.length > 0 ? [type_industry_id,'in'] : '','province_code':province_code.length > 0 ? [province_code,'in'] : '',title:keyword,state:1,orderBy:'create_time',sortBy:'desc'}" :auto="false" ref="list">-->
        <flat-list url="Bids/listPage" list-class="margin-top" :data="{'type_industry_id':type_industry_id.length > 0 ? type_industry_id : '','province_code':province_code.length > 0 ? province_code : '',title:title,state:1,orderBy:'create_time',sortBy:'desc',time_rage:time_rage}">
            <bids-item slot-scope="scope" :info="scope.row"></bids-item>
<!--            <bids-item slot-scope="scope" :info="scope.row" @click.native="$router.push({path:'/bids/detail/'+scope.row.id,query:{...$route.query}})"></bids-item>-->
        </flat-list>
    </div>
</template>

<script>
export default {
    name: "index",
    data(){
        return{
            keyword:'',
            title:'',

            type_industry_id:[],
            province_code:[],

            time_rage:'week',
            option2: [
                { text: '近7日', value: 'week' },
                { text: '近1月', value: 'month' },
                { text: '近3月', value: '3month' },
                { text: '近半年', value: '6month' },
            ],
        }
    },
    created() {
        this.$emit('bgColor','#f4f4f4');
    },
    mounted() {

    },
    methods:{
        onSearch(){
            console.log('search');
            // if(this.$refs.list){
            //     this.$refs.list.onRefresh();
            // }
            this.title = this.keyword;
        },
        okIndustry(list){
            this.type_industry_id = JSON.parse(JSON.stringify(list));
            // this.onSearch();
        },
        okArea(list){
            console.log(list);
            this.province_code = JSON.parse(JSON.stringify(list));

            console.log(this.province_code);
            // this.onSearch();
        }
    }
}
</script>
